import { render, staticRenderFns } from "./OMBookButton.vue?vue&type=template&id=3999ff5c&"
import script from "./OMBookButton.vue?vue&type=script&lang=ts&"
export * from "./OMBookButton.vue?vue&type=script&lang=ts&"
import style0 from "./OMBookButton.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Button: require('/tmp/build_dc55b0b5/src/components/button/Button.vue').default,ShowsDateListItem: require('/tmp/build_dc55b0b5/src/components/shows/DateListItem.vue').default,Modal: require('/tmp/build_dc55b0b5/src/components/modal/Modal.vue').default})
